import _ from 'lodash'

export const removeObjectsWithNull = obj => {
  return obj instanceof Array ?
    obj.map(item => {
      const result = removeObjectsWithNull({
        value: item,
      })
      return Reflect.ownKeys(result).length ? item : null
    }).filter(Boolean)  : (
      _(obj)
        .pickBy(_.isObject) // get only objects
        .mapValues(removeObjectsWithNull) // call only for values as objects
        .assign(_.omitBy(obj, _.isObject)) // save back result that is not object
        .omitBy(_.isNil) // remove null and undefined from object
        .omitBy(arr => _.isEmpty(arr)) // remove empty arrays
        .omitBy(val => typeof val === 'object' && Reflect.ownKeys(val).length === 0) // remove empty objects
        .value() // get value
    )
}

export const validateField = ({ name, value, validate, model, setModel, initialState }) => {
  const validators = validate ? validate instanceof Array ? validate : [validate] : null

  const validateResult = validators &&
    (validators.map(validator => validator(value, model.values, initialState.values)).filter(Boolean)[0] || undefined)

  const currentValidationState = _.get(model, `errors['${name}']`, undefined)
  if (validateResult !== currentValidationState) {
    const result = { ...model }
    if (!validateResult && result.errors) {
      delete result.errors[name]
    } else if(validateResult) {
      result.errors = {
        ...result.errors,
        [name]: validateResult,
      }
    }
    result.isValid = Reflect.ownKeys(result.errors || {}).length === 0
    setModel(result)
    return validateResult
  }
}

export const convertValue = ( value, type, integerValue ) => {
  switch (type) {
    case 'number':
    case 'select':
    case 'select-one':
      return value === '' ? '' : (integerValue || type === 'number') ? parseFloat(value) : value
    default:
      return value
  }
}

export const isDirty = ({ field,  model, initialStateValuesJSON  }) => {
  return initialStateValuesJSON !== JSON.stringify(model.values)
}

export const removeErrorsBlock = (model, pathRemove) => {
  if (model.errors) {
    const toRemove = Reflect.ownKeys(model.errors)
      .filter(key => key.includes(pathRemove))
    if (toRemove && toRemove.length > 0) {
      model.errors = _.omit(model.errors, toRemove)
    }
  }
  return model
}

export const changeErrorsPath = (model, oldPath, newPath) => {
  let errorsToAdd = {}
  Reflect.ownKeys(model.errors || {}).forEach(key => {
    if(key.includes(oldPath)) {
      errorsToAdd = {
        ...errorsToAdd,
        [key.replace(oldPath, newPath)]: model.errors[key],
      }
      delete model.errors[key]
    }
  })
  model.errors = {
    ...model.errors,
    ...errorsToAdd,
  }
  return model
}

const collectAndRemoveErrors = (model, path) => Reflect.ownKeys(model.errors || {}).reduce((acc, key) => {
  if (key.includes(path)) {
    const value = model.errors[key]
    delete model.errors[key]
    return {
      ...acc,
      [key]: value,
    }
  }
  return { ...acc }
}, {})

export const swapErrors = (model, pathOne, pathTwo) => {

  const pathOneErrors = changeErrorsPath({
    errors: collectAndRemoveErrors(model, pathOne),
  }, pathOne, pathTwo)

  const pathTwoErrors = changeErrorsPath({
    errors: collectAndRemoveErrors(model, pathTwo),
  }, pathTwo, pathOne)

  model.errors = {
    ...model.errors,
    ...pathOneErrors.errors,
    ...pathTwoErrors.errors,
  }

  return model
}

export const copyErrors = (model, pathOne, pathTwo) => {
  let errorsToAdd = {}
  Reflect.ownKeys(model.errors || {}).forEach(key => {
    if (key.includes(pathOne)) {
      errorsToAdd = {
        ...errorsToAdd,
        [key.replace(pathOne, pathTwo)]: model.errors[key],
      }
    }
  })
  model.errors = {
    ...model.errors,
    ...errorsToAdd,
  }
  return model
}

const getPathKeys = (model, path) => {
  return Reflect.ownKeys(model.errors || {}).filter(key => key.includes(path))
}

const escapeString = string => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export const correctErrorsAfterDeleteItem = (model, path, indexToRemove) => {
  const cleanedModel = removeErrorsBlock(model, `${path}[${indexToRemove}]`)
  const itemsToChange = getPathKeys(model, path)
  const toCheckRegExp = new RegExp(`${escapeString(path)}\\[(\\d+)\\]`)
  itemsToChange.reduce((acc, value) => {
    const result = value.match(toCheckRegExp)
    return [
      ...acc,
      result && result[1] && parseInt(result[1], 10) > indexToRemove && !acc.includes(parseInt(result[1], 10)) ? parseInt(result[1], 10) : null,
    ]
  }, []).filter(Boolean).sort().forEach(index => {
    changeErrorsPath(cleanedModel, `${path}[${index}]`, `${path}[${index - 1}]`)
  })

  return cleanedModel
}

export default {
  validateField,
  convertValue,
  isDirty,
  removeErrorsBlock,
  swapErrors,
  correctErrorsAfterDeleteItem,
  copyErrors,
}
